var React = require('react');

function BrowseFasterIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M66.985 45c-.547 0-.99-.44-1.016-.986C65.18 27.332 51.196 14 34 14S2.82 27.332 2.031 44.014c-.025.545-.47.986-1.016.986a.98.98 0 0 1-.984-1.017C.836 26.185 15.736 12 34 12c18.264 0 33.164 14.185 33.97 31.983A.98.98 0 0 1 66.984 45z","fill":"#5FD800","key":0}),React.createElement("path",{"d":"M53.006 32 37.555 49.862c-2.181 2.522-6.195 2.155-7.883-.72a4.87 4.87 0 0 1 2.078-6.848L53.006 32z","fill":"#5FD800","key":1})]);
}

BrowseFasterIcon.defaultProps = {"width":"68","height":"68","viewBox":"0 0 68 68","fill":"none"};

module.exports = BrowseFasterIcon;

BrowseFasterIcon.default = BrowseFasterIcon;
